import { PathResolutionService } from "./path-resolution-service";

/** The list of extensions to match for the defaul asset resolution predicate. */
export let defaultExtensionsToMatch = [".json", ".png", ".gif", ".ico", ".woff", ".svg", ".eot", ".pdf"];

/** Default path resolution predicate that Shell uses for asset resolution */
export let defaultAssetPathResolutionPredicate = (path: string) => {
  return !!defaultExtensionsToMatch.find((x) => path.endsWith(x));
};

export let forceBeaconResolutionPredicate = () => true;

export type ConfigWithPathResolutionOverrides = ng.IRequestConfig & {
  /** Note: this property is intended to exist only temporarily while teams root cause path resolution issues. brphelps to return to remove "soon". */
  _sd_force_beacon_usage?: boolean;
};

export class HttpInterceptorPathResolver {
  // @ngInject
  constructor(private assetPathResolutionService: PathResolutionService) {
    this.request = function (config: ConfigWithPathResolutionOverrides) {
      if (config) {
        let newUrl = this.assetPathResolutionService.resolvePath(
          config.url,
          config._sd_force_beacon_usage ? forceBeaconResolutionPredicate : undefined
        );
        if (newUrl != config.url) {
          config.url = newUrl;
          if (config.headers) {
            // Remove tokens on mapped asset requests, we know these should not be trying to authorize.
            delete config.headers["Authorization"];
          }
        }
      }
      return config;
    }.bind(this);
  }

  public request: (config: ConfigWithPathResolutionOverrides) => ConfigWithPathResolutionOverrides;
}

HttpInterceptorPathResolver.$inject = ["assetPathResolutionService"];
